<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Components
	import ActionMotionUrlsList from '../WebHookComponentsG1/ActionMotionUrlsList.svelte';
	import UrlsList from '../WebHookComponentsG1/UrlsList.svelte';
	import InputWithTextWrapper from '../WebHookComponentsG1/InputWithTextWrapper.svelte';
	import OneTimeRepeatetlyWrapper from '../WebHookComponentsG1/OneTimeRepeatetlyWrapper.svelte';
	import Container from '@Shelly/shelly-design-system/Container/Container.svelte';
	//Services
	import { format } from '../../../../services/i18n';
	//Helpers
	import { celsius_to_fahrenheit, get_local_ip, real_id } from '../../../../helpers/interface_helpers';
	import { save_actions } from '../WebHooksHelpers/get_actions';
	import { isValidURL } from '../../../../helpers/utilities';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	import { getNumberInputConfig } from '../../../../helpers/number_input_helpers';
	//Design system components
	import { Button, Alert } from '@Shelly/shelly-design-system';
	//Svelte helpers
	import { createEventDispatcher, onMount } from 'svelte';
	//Stores
		import { onSettingsResponse } from 'src/helpers/device_settings_helpers';

	$: settingsStore = getDeviceSettings(device.id);
	export let deviceActions, data, action, type;

	const text = $format('no_action_registered', {
		default: 'No actions registered.',
	});

	const dispatch = createEventDispatcher();
	const device = deviceActions.device;
	const id = real_id(device.id);

	let disabled = false;
	let list = data.urls;
	let tempList = data.urls;
	let showURLError = false;

	let syLabs = ['SHMOS-01', 'SHMOS-02', 'SHTRV-01'].includes(device.type); //.includes('MOS');

	let params = data.params;
	const devicesForConvertion = ['SHHT-1', 'SHWT-1', 'SHDW-1', 'SHDW-2'];

	const isFahrenheit = $settingsStore?.sensors?.temperature_unit === 'F';
	const isConvertionNeeded = devicesForConvertion.includes(device.type) && isFahrenheit; //Main problem here is that the HnT, door window and flood sensor devices cannot accept values higher than 60, so requests will be sent as celsius, but will be faked to be like fahrenheit if that is sensor setting's unit

	const minTemp = isConvertionNeeded && isFahrenheit ? -40 : -55; //-40 is lower value which device accepts if hnt and fahrneheit
	const maxTemp = isConvertionNeeded && isFahrenheit ? 140 : 125;
	const stepTemp = isConvertionNeeded && isFahrenheit ? 1 : 0.1;
	/** extract threshold value for temperature action urls
	 * by action names
	 */
	let temperature =
		type === 'sensor' || type === 'new_sensor' || syLabs
			? params?.[action.replace(/_url/, '_value')]
			: '';

	/** extract one time or repeatedly execution of action for sensor and adc actions
	 * by action names
	 */
	let onetime =
		type === 'sensor' || type === 'adc' || type === 'new_sensor'
			? params?.[action.replace(/_url/, '_onetime')]
			: '';

	/** extract voltage value threshold by action name*/
	let voltage = type === 'adc' ? params?.[action.replace(/_url/, '_value')] : '';

	/**
	 * extract acton threshold and add check for all under and over power actions
	 * mostly for SHEM -3
	 */
	let threshold =
		!action?.match(/\d/) && action?.includes('power')
			? data?.params?.[`${action?.includes('under') ? 'under' : 'over'}_power_url_threshold`]
			: data?.params?.[`${action.split('_').slice(0, -1).join('_')}_threshold`];

	let checked = data.enabled;

	let localIp = get_local_ip(id);

	onMount(() => {
		if (isConvertionNeeded && action.includes('temp')) {
			temperature = celsius_to_fahrenheit(Number(temperature)); //to fixed, for consistency. Trvs for example are integers on Fahrenheit
		}
	});

	const newActionChange = (e) => {
		e.detail.filter((action) => {
			return JSON.stringify(action.url).length > 0;
		});
		tempList = e.detail;
	};

	const addNewAction = () => {
		/**this is new devices action format*/
		list.push({ url: '', int: ['00:00', '00:00'] });
		list = list;
	};

	const saveActionsCaller = async () => {
		disabled = true;
		if (syLabs) {
			tempList.forEach((element, i) => {
				element.int = element.int.join('-').replace(/:/g, '');
				if (JSON.stringify(element.url).length < 1) handleDelete({ detail: i });
			});
			list = tempList;
		}
		list.forEach((el) => {
			let url = el?.url ? el.url : el;
			if (url && !isValidURL(url, true)) {
				disabled = false;
				showURLError = true;
			}
		});
		if (showURLError) {
			return false;
		}

		let res = await save_actions(device, checked, action, list, params, Number(data.index), localIp);
		if (res.isok) {
			dispatch('actionsUpdate');
			dispatch('close');
			data = deviceActions[device.id][action];
			if (list.length == 0 || (list.length === 1 && list[0] === '')) {
				/** because if the list is empty on saving actions we send enabled: false
				 * need to update he prop (but after save actions)
				 */
				checked = false;
			}
		} else {
			dispatch('close');
		}
		onSettingsResponse(res, device);
		disabled = false;
	};

	const handleDelete = (e) => {
		list.splice(e.detail, 1);
		list = list;
	};

	const handleTemperature = () => {
		params[action.replace(/_url/, '_value')] = +temperature;
	};

	const handleOnetimer = () => {
		onetime = !onetime;
		params[action.replace(/_url/, '_onetime')] = onetime;
	};

	const handleVoltage = () => {
		params[action.replace(/_url/, '_value')] = +voltage;
	};

	const handleThreshold = () => {
		/*** We do this to handle SHEM-3 under power actions' threshold */
		let paramName =
			!action?.match(/\d/) && action?.includes('power')
				? `${action?.includes('under') ? 'under' : 'over'}_power_url_threshold`
				: `${action.split('_').slice(0, -1).join('_')}_threshold`;

		params[paramName] = threshold;
	};
	/**
	 * May be could be handle better :()
	 */
	const formatAction = () => {
		switch (action) {
			case 'ext_temp_over_url_0':
			case 'ext_temp_over_url_1':
			case 'ext_temp_over_url_2':
			case 'temp_over_url':
				return $format('temp_over_url_description') || 'The temperature value';
			case 'ext_temp_under_url_0':
			case 'ext_temp_under_url_1':
			case 'ext_temp_under_url_2':
			case 'temp_under_url':
				return $format('temp_under_url_description') || 'The temperature value';
			case 'ext_hum_over_url':
			case 'hum_over_url':
				return $format('hum_over_url_description') || 'The humidity value';
			case 'ext_hum_under_url':
			case 'hum_under_url':
				return $format('hum_under_url_description') || 'The humidity value';

			case 'over_power_url_1':
			case 'over_power_url_2':
			case 'over_power_url_3':
			case 'over_power_url':
			case 'sum_of_all_channels_over_power_urls':
				return $format('over_power_url_description');

			case 'under_power_url_1':
			case 'under_power_url_2':
			case 'under_power_url_3':
			case 'under_power_url':
			case 'sum_of_all_channels_under_power_urls':
				return $format('under_power_url_description');

			/** may be the keys will look better if contain url_description not only _description */
			case 'motion_on':
			case 'motion_off':
			case 'motion_dark':
			case 'motion_twilight':
			case 'motion_bright':
			case 'dark_condition':
			case 'twilight_condition':
			case 'bright_condition':
			case 'tamper_alarm_on':
			case 'tamper_alarm_off':
				return $format(`${action}_url_description`);

			case 'report_url':
			default:
				return $format(`${action}_description`);
		}
	};

	//TODO - need to handle uni actions, device didn't save changes when there aren't url addresses
</script>

<!-- <ActionPreviewList {data} {action} /> -->
{#if type === 'sensor'}
	<Container padding="scrollPaddings" class="mb-s">
		<InputWithTextWrapper
			{...getNumberInputConfig()}
			text={formatAction()}
			bind:value={temperature}
			min={minTemp}
			max={maxTemp}
			step={stepTemp}
			icon={'fas fa-temperature-three-quarters'}
			callback={handleTemperature}
		/>
		<div class="mb-m mt-m">
			<UrlsList
				bind:list
				bind:showURLError
				{text}
				smallTextMargin
				message={$format('max_actions_urls', {
					default: 'URLs to hit when action is complete (max 5):',
				})}
			/>
		</div>
		<OneTimeRepeatetlyWrapper {onetime} callback={handleOnetimer} />
	</Container>
{:else if type === 'adc'}
	<Container padding="scrollPaddings" class="mb-s">
		<InputWithTextWrapper
			{...getNumberInputConfig()}
			text={formatAction()}
			bind:value={voltage}
			min={-100000}
			max={100000}
			step={0.1}
			icon={'fas fa-bolt'}
			callback={handleVoltage}
		/>
		<div class="mb-m mt-m">
			<UrlsList
				bind:list
				bind:showURLError
				smallTextMargin
				text={$format('no_url_registered')}
				message={$format('max_actions_urls')}
			/>
		</div>
		<OneTimeRepeatetlyWrapper {onetime} callback={handleOnetimer} />
	</Container>
{:else if syLabs || type === 'new_sensor'}
	{#if syLabs}
		<!-- <Container class="mb-s">
			<Text styleType="body-small" class="mb-s">
				{formatAction()}
			</Text>
		</Container> -->
	{/if}
	{#key list}
		{#if temperature}
			<Container class="mb-s" padding="scrollPaddings">
				<InputWithTextWrapper
					{...getNumberInputConfig()}
					text={$format('threshold_description', {
						values: { type: device.type, min: -55, max: 125 },
						default: `Wake up and report status if ${device.type} changes by threshold. Value must be between -55 and 125.`,
					})}
					bind:value={temperature}
					icon={'fas fa-temperature-three-quarters'}
					min={-55}
					max={125}
					step={0.1}
					callback={handleTemperature}
				/>
			</Container>
		{/if}
		{#if (type === 'new_sensor' && !action.includes('report')) || (syLabs && temperature)}
			<Container class="mb-s" padding="scrollPaddings">
				<OneTimeRepeatetlyWrapper {onetime} callback={handleOnetimer} />
			</Container>
		{/if}
		<Container class="mb-s" padding="scrollPaddings">
			<ActionMotionUrlsList
				{list}
				{text}
				bind:showURLError
				message={$format('label_active_urls', { default: 'Active URLs' })}
				on:delete={handleDelete}
				on:newActionChange={newActionChange}
			/>
		</Container>
		<Container class="mb-s" padding="scrollPaddings">
			<Button size="m" width="full" variant="secondary" on:click={addNewAction}>
				{$format('process_add', { default: 'Add' })}
			</Button>
		</Container>
	{/key}
{:else}
	<Container class="mb-s" padding="scrollPaddings">
		<Alert
			type="info"
			class="mb-s"
			heading={$format('device_settings_actions_alert', {
				default:
					'More than 2 actions can affect the normal operation of the device depending on the network infrastructure and the controlled devices.',
			})}
		/>
		{#if params}
			<InputWithTextWrapper
				{...getNumberInputConfig()}
				text={formatAction()}
				bind:value={threshold}
				min={-100000}
				max={100000}
				step={1}
				icon={'fas fa-bolt'}
				callback={handleThreshold}
			/>
		{/if}
		<div
			class={classMap({
				'mt-m': params,
			})}
		>
			<UrlsList
				bind:list
				bind:showURLError
				{text}
				smallTextMargin={params}
				message={$format('max_actions_urls', {
					default: 'URLs to hit when action is complete (max 5):',
				})}
			/>
		</div>
	</Container>
{/if}
<div class="d-flex justify-content-end mt-m">
	<Button
		size="l"
		width="full"
		class="width-md-m width-sm-full mr-s"
		variant="secondary"
		responsiveSize={{
			sm: 'm',
		}}
		on:click={() => {
			dispatch('close');
		}}
	>
		{$format('button_cancel', { default: 'Cancel' })}
	</Button>
	<Button
		size="l"
		width="full"
		class="width-md-m width-sm-full"
		icon="fas fa-save"
		responsiveSize={{
			sm: 'm',
		}}
		{disabled}
		on:click={saveActionsCaller}
	>
		{$format('button_save', { default: 'Save' })}
	</Button>
</div>
